<div
  class="sidebar-container"
  [ngClass]="{ collapse: this.isCollapsed, spread: !this.isCollapsed }"
>
  <div class="sidebar-header">
    <img class="logo" src="../../../../../assets/images/logo.svg" alt="" />
    <div (click)="this.toggleSidebar_()" class="hamburger">
      <img
        class="cancel"
        src="../../../../../assets/icons/cancel-2.svg"
        alt=""
      />
    </div>
  </div>
  <div class="nav-list">
    <app-nav-item
      [label]="'dashboard'"
      [path]="'/home'"
      [isCollapsed]="this.isCollapsed"
    ></app-nav-item>
    <app-nav-item
      [label]="'webhooks'"
      [path]="'/webhooks'"
      [isCollapsed]="this.isCollapsed"
    ></app-nav-item>
    <app-nav-item
      [label]="'requests'"
      [path]="'/requests'"
      [isCollapsed]="this.isCollapsed"
    ></app-nav-item>
    <!-- <app-nav-item
      [label]="'transactions'"
      [path]="'/dashboard/transactions'"
      [isCollapsed]="this.isCollapsed"
    ></app-nav-item>
    <app-nav-item
      [label]="'loyalty-cards'"
      [path]="'/dashboard/loyalty'"
      [isCollapsed]="this.isCollapsed"
    ></app-nav-item> -->
    <app-nav-item
      [label]="'settings'"
      [path]="'/settings'"
      [isCollapsed]="this.isCollapsed"
    ></app-nav-item>
  </div>
  <div class="siderbar-controllers">
    <!-- <div class="controller">
      <app-toggle></app-toggle>
      <span *ngIf="!this.isCollapsed" class="control-label"
        >Toggle Sandbox</span
      >
    </div> -->
    <!-- <span class="seperator"></span> -->
    <div class="controller" (click)="this.collapse()">
      <img src="../../../../../assets/icons/collapse.svg" alt="" />
      <span *ngIf="!this.isCollapsed" class="control-label">Collapse</span>
    </div>
  </div>
</div>
